// extracted by mini-css-extract-plugin
export default {"fileCardContainer":"FileCard_fileCardContainer__ASpgF","titleCard":"FileCard_titleCard__C00Zf"};